import React, { useState, useEffect, FunctionComponent } from 'react';
import cn from 'classnames';
import Select, { components } from 'react-select';
import styles from './FilterSelect.module.css';
import { ASSESTS } from '../../../constant/assest';
import { Image } from "react-bootstrap";

export interface Option {
    value: string;
    label: string;
}

export enum ThemeType {
  DEFAULT = 'defaultDropdown',
  LIGHT = 'lightDropDown',
  GREEN = 'greenDropDown',
}

export enum ThemePlacement {
    BOTTOM = "bottom",
    AUTO = "auto",
    TOP = "top"
}

interface FilterSelectProps {
    options: Option[];
    onSelect: (value: string) => void;
    placeholder: string;
    disabled?: boolean;
    value?: string;
    isMulti?: boolean;
    fieldOptional?: boolean;
    invalid?: boolean;
    isLoading?: boolean;
    className?: string;
    isSearchable?: boolean;
    dropdownTheme?: ThemeType;
    placement?: ThemePlacement;
    onInputChange?: (value: string) => void;
}

const FilterSelect: FunctionComponent<FilterSelectProps> = ({
    options,
    isMulti = false,
    onSelect,
    fieldOptional,
    value,
    invalid,
    isLoading,
    className,
    isSearchable = false,
    dropdownTheme=ThemeType.DEFAULT,
    placement=ThemePlacement.AUTO,
    onInputChange,
    ...props
}) => {
    
    const [selectedOption, setSelectedOption] = useState<Option | null>(null);

    useEffect(() => {
        const selectedOptions = options.find((opt) => opt.value === value);
        setSelectedOption(selectedOptions ?? null);
    }, [value, options]);

    const handleChange = (selectedValue: any) => {
        setSelectedOption(selectedValue);
        onSelect(selectedValue?.value);
    };

    const handleInputChange = (value: string) => {
        if(onInputChange) {
            onInputChange(value)
        }
    }

    const DropdownIndicator = (props: any) => {
        return (
            <components.DropdownIndicator {...props}>
                <Image src={ASSESTS.SELECTDOWN} width={20} height={20} alt="Carret" />
            </components.DropdownIndicator>
        );
    };

    return (
        <div className={cn(styles.customSelect, styles[dropdownTheme || ''], className, invalid && styles.invalid)}>
            <Select
                {...props}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                isMulti={isMulti}
                isSearchable={isSearchable}
                options={options}
                value={selectedOption}
                onChange={handleChange}
                onInputChange={handleInputChange}
                components={{ DropdownIndicator }}
                classNamePrefix={'select'}
                className={styles.dropDownSelect}
                // menuIsOpen={true}
                menuPlacement={placement}
                menuPosition="absolute"
                classNames={{
                    control: ({ isFocused }) => cn(isFocused && styles.controlFocus, styles.control),
                    input: () => styles.dropdownInput,
                    menu: () => styles.dropDownMenu,
                    menuList: () => styles.dropDownMenuList,
                    option: ({ isSelected, isFocused }) =>
                        cn(
                            styles.dropDownOption,
                            isSelected && styles.dropDownOptionSelected,
                            isFocused && styles.dropDownOptionFocused
                        ),
                    indicatorSeparator: () => styles.indicatorSeparator,
                    dropdownIndicator: () => styles.dropdownIndicator,
                    valueContainer: () => styles.valueContainer,
                    placeholder: () => styles.placeholder,
                }}
            />
        </div>
    );
};

export default React.memo(FilterSelect) ;
